import styled from 'styled-components'

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  gap: 48px;

  h2 {
    font-weight: 600;
    font-size: 22px;
    color: var(--grey2);
  }
`

export const FirstStepContainer = styled(StepContainer)`
  padding-bottom: 64px;

  .step-content {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }

  @media only screen and (max-width: 900px) {
    padding-bottom: 43px;
    gap: 31px;

    .step-content {
      gap: 26px;
      margin-bottom: 27px;
    }
  }
`

export const SecondStepContainer = styled(StepContainer)`
  padding-bottom: 60px;

  .step-content {
    display: flex;
    flex-direction: column;
    gap: 64px;
  }

  @media only screen and (max-width: 900px) {
    padding-bottom: 44px;
    gap: 31px;

    .step-content {
      gap: 32px;
    }
  }
`

export const ThirdStepContainer = styled(StepContainer)`
  padding-bottom: 60px;

  .step-content {
    display: flex;
    flex-direction: column;
    gap: 64px;
  }

  .phone-input {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .phone-input-input {
    width: calc(100% - 50px);
    height: 50px;
    border: 1px solid var(--grey3);
    padding-left: 15px;
    margin-left: 50px;
    border-radius: 0;
  }

  .phone-input-button {
    background: white;
    border: 1px solid var(--grey3);
    border-radius: 0;
  }

  @media only screen and (max-width: 900px) {
    padding-bottom: 44px;
    gap: 31px;

    .step-content {
      gap: 32px;
    }

    .phone-input {
      gap: 18px;

      label {
        font-size: 13px;
      }
    }

    .phone-input-input {
      height: 36px;
    }
  }
`

export const FourthStepContainer = styled(StepContainer)`
  padding-bottom: 52px;

  .step-content {
    display: flex;
    flex-direction: column;
    gap: 79px;
  }

  .step-inputs {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .step-confirmation {
    display: flex;
    flex-direction: column;
    gap: 42px;
  }

  .privacy-notice {
    font-weight: 400;
    font-size: 14px;
    color: var(--grey37);

    a {
      text-decoration: underline;
      text-decoration-style: solid;
      text-decoration-offset: 0%;
      text-decoration-thickness: 0%;
    }
  }

  @media only screen and (max-width: 900px) {
    padding-bottom: 25px;
    gap: 31px;

    .step-content {
      gap: 32px;
    }

    .step-confirmation {
      gap: 34px;
    }
  }
`

export const FinishStepContainer = styled(StepContainer)`
  align-items: center;
  text-align: center;

  padding-top: 52px;
  padding-bottom: 64px;
  gap: 24px;

  .error-icon {
    width: 80px;
    height: 80px;
    background: #ff4d4f;
  }

  p {
    color: var(--grey37);
  }

  .success-check {
    margin-bottom: 18px;

    width: 115px;
    height: 115px;
  }

  @media only screen and (max-width: 900px) {
    padding-top: 48px;
    padding-bottom: 48px;
    gap: 32px;

    .success-check {
      margin-bottom: 16px;

      width: 89px;
      height: 89px;
    }
  }
`

export const ErrorMessage = styled.span`
  font-size: 12px;
  line-height: 18px;
  color: var(--red1);
`
